import { Injectable, signal } from '@angular/core';
import { Service } from '../models/api.models';

const MASTER_KEY_STORAGE = 'nexus_master_key';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  // Reactive signal for the active service context (sidebar label)
  readonly activeService = signal<Service | null>(null);

  // All services loaded from the backend (for the topbar dropdown)
  readonly availableServices = signal<Service[]>([]);

  // -- Master Key ----------------------------------------------------------

  getMasterKey(): string {
    return sessionStorage.getItem(MASTER_KEY_STORAGE) ?? '';
  }

  setMasterKey(key: string): void {
    sessionStorage.setItem(MASTER_KEY_STORAGE, key);
  }

  clearMasterKey(): void {
    sessionStorage.removeItem(MASTER_KEY_STORAGE);
  }

  hasMasterKey(): boolean {
    return !!this.getMasterKey();
  }

  // -- Service Context -----------------------------------------------------

  setActiveService(service: Service | null): void {
    this.activeService.set(service);
  }
}
